import { ConfigStore } from './ConfigStore';
import { Container } from 'hypo-container';
import { root, IAppConfig } from '@estee/elc-universal-utils';
import { SearchApiSdk } from '../api/SearchApiSdk';
import { ServiceBusController } from './ServiceBusController';
import { SearchService } from './SearchService';
import { getDecorators } from '@estee/elc-service';
import { SearchRepository } from '../internal/repositories/SearchRepository';
import { SearchResultsViewController } from '../internal/controllers/SearchResultsViewController';
import { SearchGnavInputFieldViewController } from '../internal/controllers/SearchGnavInputFieldViewController';
import { VoiceSearchViewController } from '../internal/controllers/VoiceSearchViewController';
import { Config } from '../internal/domain/entities/Config';
import { ConfigRepository } from '../internal/repositories/ConfigRepository';
import { HttpTransport } from '@estee/elc-http-transport';
import { SearchServiceStartedUseCase } from '../internal/use-cases/SearchServiceStartedUseCase';

export const diContainer = new Container();
export const serviceNames = {
    searchApiSdk: 'SEARCH_API_SDK',
    apiSdk: 'API_SDK',
    configStore: 'CONFIG_STORE',
    httpTransport: 'HTTP_TRANSPORT',
    ratingStore: 'RATING_STORE',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    searchService: 'SEARCH_SERVICE',
    searchResultsViewController: 'SEARCH_RESULTS_VIEW_CONTROLLER',
    searchGnavInputFieldViewController: 'SEARCH_GNAV_INPUT_FIELD_VIEW_CONTROLLER',
    voiceSearchViewController: 'VOICE_SEARCH_VIEW_CONTROLLER',
    searchRepository: 'SEARCH_REPOSITORY',
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY'
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setConfig = (configJSON: any) => {
    diContainer.config = configJSON;
};

diContainer
    .register(
        serviceNames.configStore,
        diContainer.factory((c) => new ConfigStore(c.config))
    )
    .register(serviceNames.configRepository, () => new ConfigRepository())
    .register(serviceNames.config, () => new Config())
    .register(serviceNames.serviceBusController, () => new ServiceBusController())
    .register(serviceNames.httpTransport, () => root.HttpTransport)
    .register(serviceNames.searchApiSdk, (c) => {
        const httpTransport = new HttpTransport();
        const configStore = c.get(serviceNames.configStore);
        const { searchConfig = {}, businessUnitId } = configStore.config;
        const {
            assemblerUrl,
            assemblerPaths,
            buidToEndecaAssemblerName,
            useSquareBrackets = false
        } = searchConfig;
        let { assemblerName } = searchConfig;

        if (buidToEndecaAssemblerName) {
            assemblerName = buidToEndecaAssemblerName[businessUnitId];
        }

        const config = {
            httpTransport,
            assemblerUrl,
            assemblerName,
            assemblerPaths,
            buid: businessUnitId,
            useSquareBrackets
        };

        return new SearchApiSdk(config);
    })
    .register(
        serviceNames.searchRepository,
        diContainer.factory(
            (c) =>
                new SearchRepository({
                    searchApiSdk: c.get(serviceNames.searchApiSdk)
                })
        )
    )
    .register(
        serviceNames.searchResultsViewController,
        (c) => new SearchResultsViewController(c.get(serviceNames.searchRepository))
    )
    .register(
        serviceNames.searchGnavInputFieldViewController,
        (c) =>
            new SearchGnavInputFieldViewController(
                c.get(serviceNames.searchRepository),
                c.get(serviceNames.config)
            )
    )
    .register(
        serviceNames.voiceSearchViewController,
        (c) => new VoiceSearchViewController(c.get(serviceNames.config))
    )
    .register(
        serviceNames.searchService,
        (c) =>
            new SearchService(async (config: IAppConfig) => {
                setConfig(config);

                c.get(serviceNames.serviceBusController);
                const configRepository = c.get(serviceNames.configRepository);
                await new SearchServiceStartedUseCase(['voiceSearch'], configRepository).execute();
            })
    );

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
